import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

// -----------------------------------------------------
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import LOGO from "./image/LOGO.png";
import "./NavBar.css";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
const NavBar = () => {
  // todo------------------------------
  const [language, setLanguage] = useState("");
  const { t } = useTranslation();
  const onChangeLang = (e) => {
    const selectedLang = e.target.value;
    setLanguage(selectedLang);
    i18n.changeLanguage(selectedLang);
    Cookies.set("language", selectedLang); // Save selected language to a cookie
    localStorage.removeItem("i18nextLng");
    // window.location.reload();
  };

  useEffect(() => {
    const savedLang = Cookies.get("language");
    if (savedLang) {
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang);
    }
  }, []);

  const [login, setLogin] = useState(true);

  const seelogin = async () => {
    const loginCookieValue = await Cookies.get("login");

    if (loginCookieValue === "true") {
      setLogin(true);
    } else {
      setLogin(false);
    }
  };

  useEffect(() => {
    seelogin();
  }, []);
  // todo------------------------------
  return (
    <div>
      <nav className="  navbar navbar-expand-lg navbar-light bg-light nav ">
        <div className="container py-2">
          {/* <Link className="navbar-brand " to="logo">
            logo
            </Link> */}
          <img src={LOGO} height={70} width={70} alt=" " />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* mean */}
          <div className="collapse navbar-collapse align-middle" id="navbarNav">
            <ul className="navbar-nav ms-auto nav_ul align-items-center navbar">
              <li className="nav-item ">
                <Link className="nav-link link" to="/">
                  {t("home")}
                </Link>
              </li>
              {login ? (
                <li className="nav-item ">
                  <Link className="nav-link link" to="/Profile">
                    {t("Profile")}
                  </Link>
                </li>
              ) : (
                <>
                  {/* <li className="nav-item ">
                    <Link className="nav-link link" to="/User">
                      User Profile
                    </Link>
                  </li> */}
                </>
              )}
              <li className="nav-item ">
                <Link className="nav-link link" to="/Gift">
                  {t("gife")}
                </Link>
              </li>
              <li className="nav-item ">
                <Link className="nav-link link" to="/aboutUs">
                  {t("About")}
                </Link>
              </li>

              <FormControl
                style={{
                  // color: "red",
                  margin: 1,
                  minWidth: 120,
                  borderRadius: 5,
                  backgroundColor: "rgb(4, 96, 187)",
                }}
              >
                <InputLabel
                  id="language-select-label"
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "white",
                  }}
                >
                  {t("lang")}
                </InputLabel>
                <Select
                  value={language || ""}
                  onChange={onChangeLang}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  style={{
                    marginTop: 8,
                    fontSize: 21,
                    color: "white",
                  }}
                >
                  <MenuItem
                    value="ku"
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    {t("Kurdish")}
                  </MenuItem>
                  <MenuItem
                    value="ar"
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    {t("Arabic")}
                  </MenuItem>
                </Select>
              </FormControl>

              {/* //todo-------------------------------------------------- */}
            </ul>
          </div>
          {/* end_navbar */}
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
